import { CommonModule } from '@angular/common';
import { AppComponentCoreModule } from './../core/app-component-core.module';
import { AppServiceModule } from './../../service/app-service.module';
import { TestModalComponent } from './test.modal';
import { NgModule } from '@angular/core';
import { AppComponentPluginModule } from './../plugin/app-component-plugin.module';
import { LoginModalComponent } from './login.modal';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExcelModalComponent } from './excel.modal';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppComponentPluginModule,
    AppServiceModule,
    AppComponentCoreModule,
  ],
  declarations: [
    TestModalComponent,
    LoginModalComponent,
    ExcelModalComponent,
  ],
  exports: [
    TestModalComponent,
    LoginModalComponent,
    ExcelModalComponent,
  ],
  entryComponents: [
    TestModalComponent,
    LoginModalComponent,
    ExcelModalComponent,
  ],
})
export class ModalModule { }



// WEBPACK FOOTER //
// ./src/app/core/component/modal/modal.module.ts